import Grid from "@mui/material/Grid2";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import FormHelperText from "@mui/material/FormHelperText";

export default function GridDropdown({
  id = "",
  key = "",
  name = "",
  columnSize = "6",
  label = "",
  defaultValue = "",
  currState = "",
  onChange = null,
  data = null,
  dataType = "keyValue",
  error,
}) {
  return (
    <Grid size={Number(columnSize)}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          label={label}
          defaultValue={defaultValue}
          value={currState}
          fullWidth
          onChange={(e, object) => onChange(e, object)}
          required={true}
          error={error}
        >
          {data && dataType === "keyNameValue"
            ? data.map((object) => (
                <MenuItem id={id} key={object.key} value={object.value} name={object.name}>
                  {object.name}
                </MenuItem>
              ))
            : ""}

          {data && dataType === "keyValue"
            ? data.map((object) => (
                <MenuItem id={id} key={key} value={object.key}>
                  {object.value}
                </MenuItem>
              ))
            : ""}

          {data && dataType === "country"
            ? data.map((object) => (
                <MenuItem id={id} key={key} value={object.country}>
                  {object.country}
                </MenuItem>
              ))
            : ""}

          {data && dataType === "countryCode"
            ? data.map((object) => (
                <MenuItem id={id} key={key} value={object.code}>
                  {object.country}
                  (+{object.code})
                </MenuItem>
              ))
            : ""}
        </Select>
        {error ? <FormHelperText error={error}>{label} is required</FormHelperText> : ""}
      </FormControl>
    </Grid>
  );
}
